import React from 'react'

export default function RequiredText() {
  return (
    <span className="fst-italic fs-6 text-danger">*</span>
  )
}
